import React from 'react';
import { 
  Paper, BottomNavigation, BottomNavigationAction, Box 
} from '@mui/material';
import { 
  Home as HomeIcon, 
  MenuBook as ChaptersIcon, 
  AutoAwesome as WisdomIcon, 
  Bookmark as BookmarkIcon,
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useCustomTheme } from '../contexts/ThemeContext';

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  const { mode, toggleTheme } = useCustomTheme();

  const getActiveTab = () => {
    const path = location.pathname;
    if (path === '/') return 0;
    if (path.startsWith('/chapters')) return 1;
    if (path.startsWith('/situations')) return 2;
    if (path.startsWith('/bookmarks')) return 3;
    return 0;
  };

  return (
    <Box 
      sx={{ 
        display: { xs: 'block', md: 'none' }, 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        width: '100%',
        zIndex: 9999,
        pointerEvents: 'auto'
      }}
    >
      <Paper 
        elevation={16} 
        sx={{ 
          borderRadius: '18px 18px 0 0',
          bgcolor: mode === 'dark' ? 'rgba(15, 18, 26, 0.95)' : 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          borderTop: '1px solid rgba(255, 140, 0, 0.3)',
          borderLeft: 'none',
          borderRight: 'none',
          borderBottom: 'none',
          boxShadow: '0 -8px 24px rgba(0, 0, 0, 0.4)'
        }}
      >
        <BottomNavigation
          showLabels
          value={getActiveTab()}
          onChange={(event, newValue) => {
            if (newValue === 0) navigate('/');
            if (newValue === 1) navigate('/chapters');
            if (newValue === 2) navigate('/situations');
            if (newValue === 3) navigate('/bookmarks');
          }}
          sx={{
            bgcolor: 'transparent',
            height: 64,
            '& .MuiBottomNavigationAction-root': {
              color: mode === 'dark' ? '#94A3B8' : '#64748B',
              minWidth: 'auto',
              padding: '6px 0',
              '&.Mui-selected': {
                color: '#FF8C00'
              }
            }
          }}
        >
          <BottomNavigationAction label={t('menu.home')} icon={<HomeIcon />} />
          <BottomNavigationAction label={t('menu.chapters')} icon={<ChaptersIcon />} />
          <BottomNavigationAction label={t('menu.lifeWisdom') || 'Wisdom'} icon={<WisdomIcon />} />
          <BottomNavigationAction label={t('menu.savedVerses') || 'Saved'} icon={<BookmarkIcon />} />
          <BottomNavigationAction 
            label={mode === 'dark' ? 'Light' : 'Dark'} 
            icon={mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
            onClick={(e) => {
              e.preventDefault();
              toggleTheme();
            }}
          />
        </BottomNavigation>
      </Paper>
    </Box>
  );
};

export default MobileBottomNav;
